import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Mic, Store, Calendar, LogOut, Crown, Shield, ChevronDown, Users, UserCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { annonceAPI, evenementAPI, adminAPI, publicAPI } from '../services/api';

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated, isComite, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);
  const [modules, setModules] = useState({ module_stamm_enabled: 'true' });

  useEffect(() => {
    publicAPI.getModules().then(r => setModules(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!isAuthenticated || !isComite) return;
    const load = async () => {
      try {
        const [ann, ev, pu] = await Promise.allSettled([
          annonceAPI.getPending(),
          evenementAPI.getPending(),
          adminAPI.getPendingUsers(),
        ]);
        const count =
          (ann.status === 'fulfilled' ? ann.value.data.length : 0) +
          (ev.status === 'fulfilled' ? ev.value.data.length : 0) +
          (pu.status === 'fulfilled' ? pu.value.data.length : 0);
        setPendingCount(count);
      } catch {}
    };
    load();
    const interval = setInterval(load, 60000);
    return () => clearInterval(interval);
  }, [isAuthenticated, isComite]);

  const stammEnabled = modules.module_stamm_enabled !== 'false';

  const navItems = [
    { label: 'QSO', path: '/qso' },
    { label: 'Annonces', path: '/annonces' },
    ...(stammEnabled ? [{ label: 'Stamm', path: '/stamm' }] : []),
    { label: 'Agenda', path: '/agenda' },
  ];

  const handleLogout = () => { logout(); setMenuOpen(false); navigate('/qso'); };

  return (
    <div style={{minHeight:'100vh',display:'flex',flexDirection:'column',backgroundColor:'#F4F5F7',fontFamily:'-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif'}}>

      {/* ── HEADER fixe ── */}
      <header style={{backgroundColor:'#111827',color:'white',flexShrink:0,position:'sticky',top:0,zIndex:200,width:'100%'}}>

        {/* Bannière */}
        <div style={{maxWidth:1100,margin:'0 auto',lineHeight:0}}>
          <img src="/banner.jpg" alt="HB9G" className="banner-img" style={{display:'block',width:'100%',height:'auto',maxHeight:80,objectFit:'cover',objectPosition:'center'}} />
        </div>

        {/* Barre de navigation — cachée sur mobile (remplacée par bottom nav) */}
        <div style={{borderTop:'1px solid rgba(255,255,255,0.07)',backgroundColor:'rgba(0,0,0,0.25)'}} className="desktop-nav">
          <div style={{maxWidth:1100,margin:'0 auto',padding:'0 16px',height:44,display:'flex',alignItems:'center',justifyContent:'space-between'}}>

            <nav style={{display:'flex',gap:2}}>
              {navItems.map(item => {
                const active = location.pathname.startsWith(item.path);
                return (
                  <Link key={item.path} to={item.path} style={{
                    padding:'5px 12px', borderRadius:6, fontSize:'0.8125rem', fontWeight: active ? 600 : 400,
                    textDecoration:'none', letterSpacing:'0.01em',
                    backgroundColor: active ? 'rgba(255,255,255,0.15)' : 'transparent',
                    color: active ? 'white' : 'rgba(255,255,255,0.6)',
                    transition:'all 0.15s',whiteSpace:'nowrap',
                  }}>{item.label}</Link>
                );
              })}
            </nav>

            <div style={{display:'flex',alignItems:'center',gap:8}}>
              {isAuthenticated ? (
                <div style={{position:'relative'}}>
                  <button onClick={() => setMenuOpen(!menuOpen)} style={{
                    display:'flex',alignItems:'center',gap:6,
                    backgroundColor:'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.18)',
                    color:'white',borderRadius:6,padding:'0 10px',height:30,
                    fontFamily:'monospace',fontSize:'0.75rem',fontWeight:600,cursor:'pointer',letterSpacing:'0.05em',
                  }}>
                    {user?.indicatif} <ChevronDown style={{width:12,height:12,opacity:0.7}} />
                  </button>
                  {menuOpen && (
                    <>
                    <div onClick={() => setMenuOpen(false)} style={{position:'fixed',inset:0,zIndex:199}}/>
                    <div style={{position:'absolute',right:0,top:'calc(100% + 6px)',width:200,backgroundColor:'white',borderRadius:10,boxShadow:'0 4px 24px rgba(0,0,0,0.18)',overflow:'hidden',border:'1px solid #E5E7EB',zIndex:200}}>
                      {isComite && (
                        <button onClick={() => navigate('/comite')} style={{width:'100%',display:'flex',alignItems:'center',gap:10,padding:'10px 14px',background:'none',border:'none',borderBottom:'1px solid #F3F4F6',cursor:'pointer',fontSize:'0.8125rem',color:'#111827',textAlign:'left'}}>
                          <div style={{width:24,height:24,borderRadius:6,background:'linear-gradient(135deg,#312E81,#6D28D9)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                            <Crown style={{width:12,height:12,color:'white'}}/>
                          </div>
                          <div style={{lineHeight:1.2}}>
                            <div style={{fontWeight:700,fontSize:'0.8125rem'}}>Espace Admin</div>
                            <div style={{fontSize:'0.6875rem',color:'#9CA3AF'}}>Gestion du club</div>
                          </div>
                        </button>
                      )}
                      <button onClick={() => { navigate('/profile'); setMenuOpen(false); }} style={{width:'100%',display:'flex',alignItems:'center',gap:10,padding:'9px 14px',background:'none',border:'none',borderBottom:'1px solid #F3F4F6',cursor:'pointer',fontSize:'0.8125rem',color:'#111827',textAlign:'left'}}>
                        <UserCircle style={{width:14,height:14,color:'#6B7280'}} /> Mon profil
                      </button>
                      <button onClick={handleLogout} style={{width:'100%',display:'flex',alignItems:'center',gap:10,padding:'9px 14px',background:'none',border:'none',cursor:'pointer',fontSize:'0.8125rem',color:'#DC2626',textAlign:'left'}}>
                        <LogOut style={{width:14,height:14}} /> Se déconnecter
                      </button>
                    </div>
                    </>
                  )}
                </div>
              ) : (
                <button onClick={() => navigate('/auth')} style={{
                  backgroundColor:'white',color:'#111827',fontWeight:600,borderRadius:6,
                  padding:'0 12px',height:30,fontSize:'0.8rem',border:'none',cursor:'pointer',letterSpacing:'0.01em',whiteSpace:'nowrap',
                }}>Connexion</button>
              )}
            </div>

          </div>
        </div>
      </header>

      {/* ── MAIN scrollable ── */}
      <main className="main-content" style={{flex:1,paddingBottom:'5rem'}}>
        <div className="page-padding" style={{maxWidth:1100,margin:'0 auto',padding:'16px 12px'}}>
          <Outlet />
        </div>
      </main>

      {/* ── MOBILE NAV ── */}
      <nav className="bottom-nav" style={{position:'fixed',bottom:0,left:0,right:0,backgroundColor:'white',borderTop:'1px solid #E5E7EB',zIndex:100,display:'flex',backdropFilter:'blur(8px)',paddingBottom:'calc(env(safe-area-inset-bottom, 0px) + 4px)'}}>
        {[
          {label:'QSO',path:'/qso',icon:<Mic style={{width:18,height:18}}/>},
          {label:'Annonces',path:'/annonces',icon:<Store style={{width:18,height:18}}/>},
          ...(stammEnabled ? [{label:'Stamm',path:'/stamm',icon:<Users style={{width:18,height:18}}/>}] : []),
          {label:'Agenda',path:'/agenda',icon:<Calendar style={{width:18,height:18}}/>},
        ].map(item => {
          const active = location.pathname.startsWith(item.path);
          return (
            <Link key={item.path} to={item.path} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:1,padding:'8px 0',textDecoration:'none',color: active ? '#111827' : '#9CA3AF',position:'relative',fontSize:'0.625rem',fontWeight: active ? 700 : 400}}>
              {active && <span style={{position:'absolute',top:0,left:'50%',transform:'translateX(-50%)',width:28,height:2,backgroundColor:'#111827',borderRadius:1}}/>}
              {item.icon}{item.label}
            </Link>
          );
        })}
        {/* Bouton connexion dans bottom nav si non connecté */}
        {!isAuthenticated && (
          <button onClick={()=>navigate('/auth')} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:1,padding:'8px 0',background:'none',border:'none',cursor:'pointer',color:'#6366F1',fontSize:'0.625rem',fontWeight:700}}>
            <Shield style={{width:18,height:18}}/>
            Connexion
          </button>
        )}
        {isAuthenticated && (
          <div style={{flex:1,position:'relative'}}>
            <button onClick={()=>setMenuOpen(!menuOpen)} style={{width:'100%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:1,padding:'8px 0',background:'none',border:'none',cursor:'pointer',color:'#111827',fontSize:'0.625rem',fontWeight:700}}>
              <span style={{position:'relative',display:'inline-flex'}}>
                <Shield style={{width:18,height:18}}/>
                {isComite && pendingCount > 0 ? (
                  <span style={{position:'absolute',top:-6,right:-8,backgroundColor:'#EF4444',color:'white',fontSize:'0.5625rem',fontWeight:800,minWidth:16,height:16,borderRadius:8,display:'flex',alignItems:'center',justifyContent:'center',padding:'0 3px',lineHeight:1,border:'2px solid white',boxShadow:'0 1px 4px rgba(0,0,0,0.25)'}}>{pendingCount > 99 ? '99+' : pendingCount}</span>
                ) : (
                  <span style={{position:'absolute',bottom:-1,right:-3,backgroundColor:'#22C55E',width:8,height:8,borderRadius:'50%',border:'2px solid white'}}/>
                )}
              </span>
              {(user?.indicatif||'').slice(0,6)}
            </button>
            {menuOpen && (
              <><div onClick={() => setMenuOpen(false)} style={{position:'fixed',inset:0,zIndex:299}}/>
              <div style={{position:'absolute',bottom:'calc(100% + 4px)',right:4,width:180,backgroundColor:'white',borderRadius:10,boxShadow:'0 4px 24px rgba(0,0,0,0.18)',overflow:'hidden',border:'1px solid #E5E7EB',zIndex:300}} onClick={e=>e.stopPropagation()}>
                {isComite && (
                  <button onClick={()=>{navigate('/comite');setMenuOpen(false);}} style={{width:'100%',display:'flex',alignItems:'center',gap:10,padding:'10px 14px',background:'none',border:'none',borderBottom:'1px solid #F3F4F6',cursor:'pointer',fontSize:'0.8125rem',color:'#111827',textAlign:'left'}}>
                    <Crown style={{width:14,height:14,color:'#7C3AED'}}/> Espace Admin
                  </button>
                )}
                <button onClick={()=>{navigate('/profile');setMenuOpen(false);}} style={{width:'100%',display:'flex',alignItems:'center',gap:10,padding:'9px 14px',background:'none',border:'none',borderBottom:'1px solid #F3F4F6',cursor:'pointer',fontSize:'0.8125rem',color:'#111827',textAlign:'left'}}>
                  <UserCircle style={{width:14,height:14,color:'#6B7280'}}/> Mon profil
                </button>
                <button onClick={handleLogout} style={{width:'100%',display:'flex',alignItems:'center',gap:10,padding:'9px 14px',background:'none',border:'none',cursor:'pointer',fontSize:'0.8125rem',color:'#DC2626',textAlign:'left'}}>
                  <LogOut style={{width:14,height:14}}/> Se déconnecter
                </button>
              </div>
              </>
            )}
          </div>
        )}
      </nav>

    </div>
  );
};

export default Layout;
